// Import modules
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import SmoothScroll from './modules/_smooth-scroll'
import VideoModal from './modules/_video-modal'
import ScrollHandlers from './modules/_scroll-handlers'
import wpmlDropdown from './modules/_wpml-dropdown'
import FloatingLabels from './modules/_floating-labels'
import PositionMap from './modules/_position-map'
import SignupBox from './modules/_signup-box'
import Modal from './modules/_modal'
import IpRedirect from 'modules/_ip-redirect'
import LanguageSwitcher from 'modules/_language-switcher'
import LogoWall from 'modules/_logo-wall'
import initDocumentToc from './modules/_document-toc'

// Use modules
Navigation()
ObjectFit()
Print()
SmoothScroll()
VideoModal()
ScrollHandlers()
wpmlDropdown()
FloatingLabels()
PositionMap()
SignupBox()
Modal()
IpRedirect()
LanguageSwitcher()
LogoWall()
initDocumentToc()

/**
 * If you want to use React in this project, just use the function below:
 * require('./app');
 */
